import {HotelsThankYouInitialState, ThankYouActionTypes} from './hotels-thankyou-types';

import {UPDATE_THANKYOU_LOADING_STATUS, UPDATE_THANKYOU_DATA, UPDATE_THANKYOU_INITIAL_DATA} from './constants';

const initialState: HotelsThankYouInitialState = {
  loading: false,
  id: '',
  thankyouData: {
    booking_id: '',
    cancellation_policies: [],
    cancellation_policy_breakup: {},
    fcdt: '',
    hotel_details: {},
    important_info: {},
    payment_id: '',
    provbooking_id: '',
    room_details: {},
    status: ''
  }
};

export default function reviewReducer(state = initialState, action: ThankYouActionTypes) {
  switch (action.type) {

    case UPDATE_THANKYOU_LOADING_STATUS:
      return {
        ...state,
        loading: action.status,
      };

    case UPDATE_THANKYOU_DATA:
      return {
        ...state,
        thankyouData: action.actionData,
        loading: action.status,
      };
    
      case UPDATE_THANKYOU_INITIAL_DATA:
      return {
        ...state,
        id: action.id
      };

    default:
      return state;
  }
}
